const fmtDate = (d) => { if (!d) return ""; const x = new Date(d); return isNaN(x) ? String(d) : x.toLocaleDateString("en-GB", { timeZone: "UTC" }).replace(/\//g, "-"); };

const IdCardTemplate = (student) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>ID Card</title>
  <style>
    @font-face { font-family: 'Rubik'; font-style: normal; font-weight: 400; src: url(${student.rubikRegularBase64}) format('truetype'); }
    @font-face { font-family: 'Rubik'; font-style: normal; font-weight: 700; src: url(${student.rubikBoldBase64}) format('truetype'); }
    @page { size: 54mm 85.6mm; margin: 0; }
    * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    body { font-family: 'Rubik', sans-serif; margin: 0; padding: 0; }
    .id-card { width: 54mm; height: 85.6mm; background: #fff; display: flex; flex-direction: column; overflow: hidden; break-after: page; }
    .id-card:last-child { break-after: auto; }
    .header { display: flex; align-items: center; gap: 1.5mm; padding: 2.5mm 2mm 0; }
    .header img { width: 11mm; height: 11mm; object-fit: contain; flex-shrink: 0; }
    .header-text { flex: 1; text-align: center; line-height: 1.25; }
    .charities { font-size: 5pt; font-weight: 700; }
    .college { font-size: 7.5pt; font-weight: 700; }
    .address { font-size: 3.6pt; color: #374151; }
    .badge { display: inline-block; margin-top: 0.8mm; font-size: 4.5pt; font-weight: 700; border: 0.25mm solid #eab308; padding: 0.2mm 1.2mm; }
    .photo-wrap { display: flex; justify-content: center; margin-top: 2mm; }
    .photo { width: 24mm; height: 29mm; object-fit: cover; border: 0.3mm solid #111; }
    .details { padding: 2mm 4mm 0; font-size: 6.5pt; line-height: 1.5; }
    .label { font-weight: 700; color: #9f1239; }
    .value { font-weight: 700; color: #111; }
    .sign-row { margin-top: auto; display: flex; padding: 0 1mm 1mm; }
    .sign { flex: 1; height: 8mm; padding: 0 1mm; }
    .sign img { width: 100%; height: 100%; object-fit: contain; }
    .footer { display: flex; background: #fbbf24; padding: 1.2mm 1mm; font-size: 4.5pt; font-weight: 700; }
    .footer span { flex: 1; text-align: center; }
    .back { flex: 1; display: flex; flex-direction: column; padding: 8mm 4mm 6mm; font-size: 6.5pt; line-height: 1.7; }
    .back .label { color: #111; }
    .back .value { font-weight: 400; }
    .return { margin-top: auto; font-size: 6pt; line-height: 1.5; }
  </style>
</head>
<body>
  <!-- Front -->
  <div class="id-card">
    <div class="header">
      <img src="${student.agnelLogoBase64}" alt="Logo">
      <div class="header-text">
        <div class="charities">AGNEL CHARITIES</div>
        <div class="college">AGNEL SCHOOL OF LAW</div>
        <div class="address">Agnel Technical Education Complex, Sector-9A, Vashi, Navi Mumbai.<br>www.agnelschooloflaw.com | +91 2227771000 | asl@agnelschooloflaw.com</div>
        ${student.academicYear ? `<div class="badge">${student.academicYear}</div>` : ""}
      </div>
    </div>
    <div class="photo-wrap"><img class="photo" src="${student.studentPhotoUrl}" alt="Student"></div>
    <div class="details">
      <div><span class="label">Name :</span> <span class="value">${[student.studentDetails.firstName, student.studentDetails.middleName, student.studentDetails.lastName].filter(Boolean).join(" ").toUpperCase()}</span></div>
      <div><span class="label">Course :</span> <span class="value">${(student.academicDetails.program || "").toUpperCase()}</span></div>
      <div><span class="label">Roll no :</span> <span class="value">${student.academicDetails.rollNumber || ""}</span></div>
      <div><span class="label">Date of Birth :</span> <span class="value">${fmtDate(student.studentDetails.dateOfBirth)}</span></div>
      <div><span class="label">Year of Joining :</span> <span class="value">${student.academicDetails.yearOfJoining || ""}</span></div>
    </div>
    <div class="sign-row">
      <div class="sign">${student.studentSignUrl ? `<img src="${student.studentSignUrl}" alt="">` : ""}</div>
      <div class="sign"><img src="${student.principalSignBase64}" alt=""></div>
      <div class="sign"><img src="${student.collegeSealBase64}" alt=""></div>
    </div>
    <div class="footer"><span>Student Signature</span><span>Principal</span><span>College Seal</span></div>
  </div>
  <!-- Back -->
  <div class="id-card">
    <div class="back">
      <div><span class="label">Blood Group :</span> <span class="value">${student.studentDetails.bloodGroup || ""}</span></div>
      <div><span class="label">Mobile No :</span> <span class="value">${student.studentDetails.studentMobileNumber || ""}</span></div>
      <div><span class="label">E-mail :</span> <span class="value">${student.studentDetails.emailAddress || ""}</span></div>
      <div><span class="label">Address :</span> <span class="value">${student.studentDetails.address || ""}</span></div>
      <div class="return"><b>If Found please return to:</b><br>Agnel School of Law,<br>Sector-9A, Vashi, Navi Mumbai,<br>Maharashtra, India, PIN - 400703.</div>
    </div>
  </div>
</body>
</html>
`;

export default IdCardTemplate;